import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Heading,
  HStack,
} from "@chakra-ui/react";
import CodesetSelect from "./CodesetSelect";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";

const AddressesEditor = ({
  addresses = [],
  onChange,
  size = "md",
}) => {
  const [localAddresses, setLocalAddresses] = useState(addresses);

  useEffect(() => {
    setLocalAddresses(addresses);
  }, [addresses]);

  const handleChange = (index, field, value) => {
    const updated = [...localAddresses];
    updated[index][field] = value;
    setLocalAddresses(updated);
    onChange(updated);
  };

  const handleAdd = () => {
    const newAddress = {
      type: "",
      numberAndStreet: "",
      subentityCode: "",
      cityName: "",
      postalCode: "",
      countryCode: "",
    };
    const updated = [...localAddresses, newAddress];
    setLocalAddresses(updated);
    onChange(updated);
  };

  const handleDelete = (index) => {
    const updated = [...localAddresses];
    updated.splice(index, 1);
    setLocalAddresses(updated);
    onChange(updated);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} borderColor="gray.500">
      <HStack mb={3} justifyContent="flex-start">
        <Heading size={size}>Addresses</Heading>
        <IconButton icon={<HiOutlinePlus />} size={size} onClick={handleAdd} />
      </HStack>

      <Table variant="simple" size={size}>
        <Thead>
          <Tr>
            <Th fontSize={size}>Type</Th>
            <Th fontSize={size}>Number & Street</Th>
            <Th fontSize={size}>Subentity</Th>
            <Th fontSize={size}>City</Th>
            <Th fontSize={size}>Postal Code</Th>
            <Th fontSize={size}>Country</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {localAddresses.map((address, idx) => (
            <Tr key={idx}>
              <Td>
                <CodesetSelect
                  codesetCode="3299"
                  value={address.type ? { code: address.type, description: "" } : null}
                  onChange={(val) => handleChange(idx, "type", val.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <Input
                  size={size}
                  height="32px"
                  value={address.numberAndStreet || ""}
                  onChange={(e) => handleChange(idx, "numberAndStreet", e.target.value)}
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode="A54"
                  value={address.subentityCode ? { code: address.subentityCode, description: "" } : null}
                  onChange={(val) => handleChange(idx, "subentityCode", val.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <Input
                  size={size}
                  height="32px"
                  value={address.cityName || ""}
                  onChange={(e) => handleChange(idx, "cityName", e.target.value)}
                />
              </Td>
              <Td>
                <Input
                  size={size}
                  height="32px"
                  value={address.postalCode || ""}
                  onChange={(e) => handleChange(idx, "postalCode", e.target.value)}
                />
              </Td>
              <Td>
                <CodesetSelect
                  codesetCode="iso3166"
                  value={address.countryCode ? { code: address.countryCode, description: "" } : null}
                  onChange={(val) => handleChange(idx, "countryCode", val.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <IconButton
                  icon={<HiOutlineTrash />}
                  size={size}
                  onClick={() => handleDelete(idx)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default AddressesEditor;
